import { Flex } from "antd"
import { useTranslation } from "react-i18next"

import InfoTooltip from "../../../../../../../Components/InfoTooltip/InfoTooltip"
import Select from "../../../../../../../Components/Select"
import { mergeOptionTooltips } from "../../../utils/optionTooltipMerge"
import { tLiteral } from "../../../utils/questionText"
import { visibleOptions } from "../../../utils/showIf"
import CardSelect from "../../CardSelect/CardSelect"

import chipStyles from "../../chips.module.less"
import styles from "../questionField.module.less"

// A `variant` renders the single-select as the icon CardSelect instead of a dropdown.
// Same value contract, so nothing else changes.
const CARD_VARIANTS = ["cards", "rows", "pills"]

const SelectControl = ({ question, value, status, onChange, onTouch, buildingBlocks }) => {
  const { t } = useTranslation()

  const opts = mergeOptionTooltips(visibleOptions(question, buildingBlocks), question.key)
  // antd Select only shows its placeholder when `value` is `undefined`; passing `null`
  // swallows it. Normalize empty/null so an empty dropdown reads "Select an option"
  // instead of showing nothing.
  const v = value === "" || value == null ? undefined : value
  const pick = (val) => {
    onTouch()
    onChange(val)
  }

  if (CARD_VARIANTS.includes(question.variant)) {
    return (
      <CardSelect
        layout={question.variant}
        value={v ?? null}
        options={opts}
        ariaLabel={question.label}
        status={status}
        onChange={pick}
        t={t}
      />
    )
  }

  // Per-option explainer: when options carry a `tooltip`, render an InfoTooltip beside
  // each option in the dropdown (optionRender keeps it out of the selected-value
  // display). stopPropagation so reading the tooltip does not select the option.
  const hasOptionTips = opts.some((o) => o.tooltip)

  return (
    <Select
      size="large"
      value={v}
      placeholder={tLiteral(t, question.placeholder) ?? t("Select an option")}
      options={opts.map((o) => ({ value: o.value, label: t(o.label), tooltip: o.tooltip }))}
      optionRender={
        hasOptionTips
          ? (oriOption) => (
              <Flex align="center" gap={4} className={styles.selectOpt}>
                <span>{oriOption.label}</span>
                {oriOption?.data?.tooltip ? (
                  <span className={chipStyles.selectOptTip} onClick={(e) => e.stopPropagation()}>
                    <InfoTooltip title={t(oriOption.data.tooltip)} />
                  </span>
                ) : null}
              </Flex>
            )
          : undefined
      }
      onChange={pick}
      allowClear
      status={status}
      style={{ minWidth: 320 }}
    />
  )
}

export default SelectControl
